module.exports = __webpack_public_path__ + "img/creationProduitsHM.a3391c6d.png";